import React from "react";
import business from '../Images/Business-Premium.svg';
import policies from '../Images/Policies-sold.svg';
import claim from '../Images/Claims-assisted.svg';
import "../HomePage/OtherLink.css";

const OtherLink = () => {
    return (
        <div className="otherLinksSmc">
            <div className="StepsRow">
                <div className="StepsColm">
                    <img src={business} />
                    <div>
                        <small>Business Premium<br /><b>28.84 Billion +</b></small>
                    </div>
                </div>
                <div className="StepsColm">
                    <img src={policies} />
                    <div>
                        <small>Policies sold<br /><b>11 Million +</b></small>
                    </div>
                </div>
                <div className="StepsColm">
                    <img src={claim} />
                    <div>
                        <small>Claims assisted<br /><b>2.04 Million +</b></small>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default OtherLink;